import React from 'react';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAppSelector } from '../../../../redux/hooks';

// Components
import TemplatesList from './TemplatesList';
import TemplateEditor from './TemplateEditor';

const Templates: React.FC = () => {
  const colors = useAppSelector((state) => state.theme.colors);
  const { templateId } = useParams<{ templateId?: string }>();

  // FIX: Add media query to handle mobile sidebar width
  const isMobile = useMediaQuery('(max-width:600px)');
  const sidebarWidth = `max(${isMobile ? 70 : 125}px, 5vw)`;

  return (
    <Box
      sx={{
        // FIX: Use dynamic sidebarWidth for responsive layout
        width: `calc(100vw - ${sidebarWidth})`,
        height: 'calc(100vh - 5vh)',
        p: isMobile ? 1.5 : 3, // Less padding on mobile
        backgroundColor: colors?.interface,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        top: '5vh',
        left: sidebarWidth,
        boxSizing: 'border-box',
      }}
    >
      {templateId ? <TemplateEditor /> : <TemplatesList />}
    </Box>
  );
};

export default Templates;